import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=071c0a4c&scoped=true"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"
import style0 from "./Solution.vue?vue&type=style&index=0&id=071c0a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-load_788e664a9ff7579ae6a3c1e6a41cd8e7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c0a4c",
  null
  
)

export default component.exports